import styled, { css, Sizes } from 'styled-components';

type InfoProps = {
  color?: 'primary' | 'secondary' | 'yellow' | 'red' | 'green' | 'blue';
  mb?: Sizes;
  padding?: Sizes;
};

export const InfoStyles = css<InfoProps>`
  display: block;
  margin-bottom: ${(props) => props.theme.sizes[props.mb || 'small']};
  padding: ${(props) =>
    props.padding ? props.theme.sizes[props.padding] : props.theme.sizes.xsmall};
  font-weight: ${(props) => props.theme.font.weights.regular};
  border: 1px solid ${(props) => props.theme.palette[props.color || 'yellow'].main};
  background-color: ${(props) => props.theme.palette[props.color || 'yellow'][100]};
  border-radius: ${(props) => props.theme.roundedCorners.xsmall};
`;

export const Info = styled.strong<InfoProps>`
  ${InfoStyles};
`;
